import { render } from "./UserNotificationPopUp.vue?vue&type=template&id=574efcb9"
import script from "./UserNotificationPopUp.vue?vue&type=script&lang=js"
export * from "./UserNotificationPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Comunications/UserNotificationPopUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "574efcb9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('574efcb9', __exports__)) {
    api.reload('574efcb9', __exports__)
  }
  
  module.hot.accept("./UserNotificationPopUp.vue?vue&type=template&id=574efcb9", () => {
    api.rerender('574efcb9', render)
  })

}


export default __exports__